import { FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxInputComponent } from './rx-input.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RxIconModule, RxInputComponent],
  exports: [RxInputComponent],
})
export class RxInputModule {}
